import Vue from 'vue'
import Router from 'vue-router'
import member from './member.js'
import step from './step.js'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [

    {
      path: '/',
      name: 'index',
      meta: {
        title: ''
      },
      component: () => import('@/views/index/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => import('@/views/member/memberlogin.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: '注册'
      },
      component: () => import('@/views/member/membersignup.vue')
    },
    {
      path: '/service_protocol',
      name: 'service_protocol',
      meta: {
        title: '用户服务协议'
      },
      component: () => import('@/views/member/serviceprotocol.vue')
    },
    {
      path: '/forgetpassword',
      name: 'forgetpassword',
      meta: {
        title: '忘记密码'
      },
      component: () => import('@/views/member/forgetpassword.vue')
    },
    {
      path: '/retrievePwd',
      name: 'retrievePwd',
      meta: {
        title: '忘记密码'
      },
      component: () => import('@/views/member/retrievePwd')
    },
    {
      path: '/recommend',
      name: 'recommend',
      meta: {
        title: '协议专区'
      },
      component: () => import('@/views/promotion/recommendlist.vue')
    },
    {
      path: '/order/flashsale',
      name: 'orderflashsale',
      meta: {
        title: '确认订单信息'
      },
      component: () => import('@/views/order/shoporderflashsale.vue')
    },
    {
      path: '/temai',
      name: 'temai',
      meta: {
        title: '供品特卖'
      },
      component: () => import('@/views/promotion/actspeciallist.vue')
    },
    {
      path: '/temai/list',
      name: 'temailist',
      meta: {
        title: '特卖场'
      },
      component: () => import('@/views/promotion/actspecialproductlist.vue')
    },
    {
      path: '/brand',
      name: 'brand',
      meta: {
        title: '品牌馆'
      },
      component: () => import('@/views/brand/brand.vue')
    },
    {
      path: '/brand/list',
      name: 'brandlist',
      meta: {
        title: ''
      },
      component: () => import('@/views/brand/brandproductlist.vue')
    },
    {
      path: '/coupon',
      name: 'coupon',
      meta: {
        title: '优券集市'
      },
      component: () => import('@/views/promotion/couponlist.vue')
    },
    {
      path: '/jifen',
      name: 'jifen',
      meta: {
        title: '积分商城'
      },
      component: () => import('@/views/promotion/actintegrallist.vue')
    },
    {
      path: '/jifen/info',
      name: 'jifeninfo',
      meta: {
        title: '积分商城'
      },
      component: () => import('@/views/promotion/actintegraldetail.vue')
    },

    {
      path: '/order/jifen',
      name: 'orderjifen',
      meta: {
        title: '确认订单信息'
      },
      component: () => import('@/views/order/shoporderintegral.vue')
    },
    {
      path: '/product/detail',
      name: 'productdetail',
      meta: {
        title: ''
      },
      component: () => import('@/views/product/productdetail.vue')
    },
    {
      path: '/order/info',
      name: 'orderinfo',
      meta: {
        title: '确认订单信息'
      },
      component: () => import('@/views/order/shoporder.vue')
    },
    {
      path: '/cart/detailpre',
      name: 'detailpre',
      meta: {
        title: '预下订单'
      },
      component: () => import('@/views/cart/cartpre.vue')
    },
    {
      path: '/cart/detail',
      name: 'cart',
      meta: {
        title: '购物车'
      },
      component: () => import('@/views/cart/cart.vue')
    },
    {
      path: '/order/pay',
      name: 'orderPay',
      meta: {
        title: '成功提交订单'
      },
      component: () => import('@/views/order/payfor.vue')
    },
    {
      path: '/order/payZkh',
      name: 'orderPay',
      meta: {
        title: '成功提交订单'
      },
      component: () => import('@/views/order/payforZkh.vue')
    },
    {
      path: '/order/success',
      name: 'ordersuccess',
      meta: {
        title: '下单成功'
      },
      component: () => import('@/views/order/ordersuccess.vue')
    },
    {
      path: '/pay/success',
      name: 'paysuccess',
      meta: {
        title: '支付成功'
      },
      component: () => import('@/views/order/paysuccess.vue')
    },
    {
      path: '/cart/add',
      name: 'cartadd',
      meta: {
        title: '购物成功'
      },
      component: () => import('@/views/cart/cartsuccess.vue')
    },
    {
      path: '/order/weixin',
      name: 'orderweixin',
      meta: {
        title: '微信支付'
      },
      component: () => import('@/views/order/weixinpay.vue')
    },
    {
      path: '/list',
      name: 'list',
      meta: {
        title: ''
      },
      component: () => import('@/views/product/productcatelist.vue')
    },
    {
      path: '/cate',
      name: 'cate',
      meta: {
        title: ''
      },
      component: () => import('@/views/product/productlist.vue')
    },
    // 文章详情
    {
      path: '/news/article',
      name: 'newsarticle',
      meta: {
        title: ''
      },
      component: () => import('@/views/news/article.vue')
    },
    // 文章列表
    {
      path: '/news/type',
      name: 'newstype',
      meta: {
        title: ''
      },
      component: () => import('@/views/news/articlelist.vue')
    },
    // 搜索
    {
      path: '/search',
      name: 'search',
      meta: {
        title: ''
      },
      component: () => import('@/views/product/productsearchlist.vue')
    },
    // 商家
    {
      path: '/store',
      name: 'store',
      meta: {
        title: ''
      },
      component: () => import('@/views/seller/sellerindex.vue')
    },
    // 商家商品列表
    {
      path: '/store/cate',
      name: 'storecate',
      meta: {
        title: ''
      },
      component: () => import('@/views/seller/sellercateindex.vue')
    },
    // 商家介绍
    {
      path: '/store/info',
      name: 'storeinfo',
      meta: {
        title: ''
      },
      component: () => import('@/views/seller/sellerinfo.vue')
    },
    {
      path: '/product/compare',
      name: 'productcompare',
      meta: {
        title: ''
      },
      component: () => import('@/views/product/compareDetail.vue')
    },
    ...step,
    ...member

  ],
  linkActiveClass: 'myactive'
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  document.title = to.meta.title + (to.meta.title != '' ? '-' : '') + '哈电集团E采平台V2.0'
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js